import { ShowButton, useResourceDefinition } from "react-admin";

export const MyShowButton = (props) => {
  const resourceData = useResourceDefinition();

  if (!resourceData.hasShow) return null;

  return <ShowButton {...props} />;
};
